import type { AppType } from '@masterapps/api';
import { hc } from 'hono/client';
import { getClerk } from '@/store/session';

const baseUrl = import.meta.env.VITE_API_URL || '';

// Cliente RPC tipado (hono/client). Same-origin quando VITE_API_URL é vazio.
// Quando o Clerk está ativo, anexa o token da sessão (Bearer) — o
// clerkMiddleware da API valida; em modo dev (sem Clerk) não há token e a API
// trata como dev-user.
export const apiClient = hc<AppType>(baseUrl, {
  fetch: async (input: RequestInfo | URL, init?: RequestInit) => {
    const headers = new Headers(init?.headers);
    try {
      const token = await getClerk()?.session?.getToken();
      if (token) headers.set('Authorization', `Bearer ${token}`);
    } catch {
      // sem token (não logado ou Clerk indisponível) — segue sem header
    }
    return fetch(input, { ...init, headers, credentials: 'include', cache: 'no-store' });
  },
});
